import { ChatBubbleBottomCenterTextIcon, ExclamationCircleIcon, InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { classNames } from "src/helpers/classNames";

const iconMap = {
  info: InformationCircleIcon,
  warning: ChatBubbleBottomCenterTextIcon,
  danger: ExclamationCircleIcon,
};

const typeColors = {
  info: {
    primary: "text-blue-500 border-blue-400",
    secondary: "bg-blue-200",
  },
  warning: {
    primary: "text-amber-500 border-amber-400",
    secondary: "bg-amber-50",
  },
  danger: {
    primary: "text-red-500 border-red-400",
    secondary: "bg-red-200",
  },
  default: {
    primary: "text-gray-500 border-gray-300",
    secondary: "bg-gray-100",
  },
};

const sizeStyles = {
  sm: {
    icon: "h-4 w-4",
    text: "text-xs",
    padding: "px-1.5 py-1",
  },
  md: {
    icon: "h-6 w-6",
    text: "text-sm",
    padding: "px-2 py-2",
  },
  lg: {
    icon: "h-8 w-8",
    text: "text-lg",
    padding: "px-3 py-3",
  },
};

export default function InformationAlert({ content, type = "info", title, dismissible = false, size = "md" }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const Icon = iconMap[type] || InformationCircleIcon;
  const colors = typeColors[type] || typeColors["default"];
  const sizing = sizeStyles[size] || sizeStyles["md"];

  return (
    <div
      role="alert"
      className={classNames("mt-2 flex items-start gap-x-2 rounded border pr-2 transition-all duration-300 ease-in-out", colors.primary)}>
      <div className={classNames("flex items-center justify-center rounded rounded-r-none font-bold", sizing.padding, colors.secondary)}>
        <Icon className={classNames(sizing.icon, "stroke-1.5")} />
      </div>
      <div className={classNames("flex flex-grow flex-col items-start", sizing.padding)}>
        {title && <div className={classNames("font-semibold", sizing.text)}>{title}</div>}
        <div className={classNames("break-words", sizing.text)}>{content}</div>
      </div>
      {dismissible && (
        <button
          onClick={() => setVisible(false)}
          className="ml-auto mt-2 text-gray-500 hover:text-gray-700"
          aria-label="Dismiss alert">
          <XMarkIcon className={classNames("stroke-2", sizing.icon)} />
        </button>
      )}
    </div>
  );
}
